/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Token_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "Use these credentials to configure SCIM in your identity provider" |
*
* @param {Scim_Token_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_token_dialog_description = /** @type {((inputs?: Scim_Token_Dialog_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Token_Dialog_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie diese Anmeldedaten, um SCIM in Ihrem Identitätsanbieter zu konfigurieren")
	return /** @type {LocalizedString} */ ("Use these credentials to configure SCIM in your identity provider")
});